import VueI18n from '@/i18n/locale'
import { i18n } from '@/common/utils/i18n'

export const TabNames = {
  priority: {
    label: VueI18n.t('FoodB_0820__bVDh' /** 高优门店 */),
    key: 'priorityStore',
    trackIndex: 1,
  },
  area: {
    label: VueI18n.t('FoodB_030_zOTR_tsWu' /** 商圈 */),
    key: 'areaStore',
    trackIndex: 2,
  },
  my: {
    label: VueI18n.t('Gattaran_0__VQyB' /** 我负责的 */),
    key: 'myStore',
    trackIndex: 3,
  },
  all: {
    label: i18n.gettext('全部'),
    key: 'allStore',
    trackIndex: 4,
  },
  rtbo: {
    label: VueI18n.t('FoodB_process_xaxm_WPYE' /** 待RTBO */),
    key: 'rtboStore',
    trackIndex: 5,
  },
}
export const TabNameList = ['rtboStore', 'priorityStore', 'areaStore', 'myStore', 'allStore']

export const RTBOEnum = [
  {
    value: 11,
    label: `${VueI18n.t('FoodB_process_ziFN_pEHW' /** 截止昨天RTBO完成进度  */)} (${VueI18n.t(
      'Gattaran_Feedback__amKQ' /** 高 */,
    )}→${VueI18n.t('Gattaran_Feedback__urHD' /** 低 */)})`,
  },
]
